import "./assets/styles/index.css";
import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { PersistGate } from "redux-persist/integration/react";
import { useSearchParams } from "react-router-dom";

import store, { persistor } from "./store";
import ErrorBoundary from "./layouts/ErrorBoundary";
import Notifier from "./layouts/Notifier";
import PageLoader from "./layouts/PageLoader";
import Header from "./layouts/Header";
import AppRoutes from "./routes";
import { isFeatureActive, setFeatureActive } from "./utils/featureFlag";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#C60C30",
    },
  },
});

function App() {
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    window.__isFeatureActive = isFeatureActive;
    setFeatureActive(searchParams.get("feature"));
  }, [searchParams]);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <Header />
            <AppRoutes />
            <Notifier />
            <PageLoader />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
